import Richtext from './richtext';

export class TitleBannerProps {
  subtitle: Richtext | null;

  title: string;

  titleColor: string;

  constructor(props: any) {
    this.subtitle = props.subtitle ? new Richtext(props.subtitle) : null;
    this.title = props.title;
    this.titleColor = props.titleFontColor || '#000';
  }
}

export default TitleBannerProps;
